import React, { useEffect, useState } from 'react'
import CreateInvoice from './Sales/CreateInvoice'
import StatusCard from "../components/status-card/StatusCard";
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllSales } from '../redux/features/sales.features';
import Table from '../components/table/Table';

const Invoice = () => {

  
const invoiceTableHead = [
  "invoice-no",
  "invoice-date",
  "invoice type", //sales //on-approval
  "invoice payment type", //cash //credit 
  "invoice foreign",
  "invoice total",
  "invoice discount",
  "invoice grand total",
  "invoice advance amount",
  "invoice paid amount",
  "invoice due amount",
  "invoice status",
  "Action",
];

const renderHead = (item, index) => <th key={index}>{item}</th>;

const renderBody = (item, index) => (
  <tr key={index}>
    {/* <td>{item.id}</td> */}
    <td>{item.invoiceNumber}</td>
    <td>{item.invoiceDate}</td>
    <td>{item.invoiceType}</td>
    <td>{item.invoicePaymentType}</td>
    <td>{item.foreignInvoice}</td>
    <td>{item.invoiceTotalAmount}</td>
    <td>{item.invoiceTotalDiscountAmount}</td>
    <td>{item.invoicePayableTotal}</td>
    <td>{item.invoiceAdvanceAmount}</td>
    <td>{item.invoicePaidAmount}</td>
    <td>{item.invoiceBalanceAmount}</td>
    <td>{item.invoiceStatus}</td>
    <td className="text-right flex items-center">
      <div className="bg-red-500 rounded p-2 bx bx-edit mx-2"></div>
      <div className="bg-green-500 rounded p-2 bx bx-show mx-2"></div>
    </td>
  </tr>
);

const dispatch = useDispatch();
let salesState = useSelector((state) => {
  return state.salesReducer;
});

let { sales, loading } = salesState;
const [showInvoiceList, setShowInvoiceList]= useState(false)

useEffect(() => {
 dispatch(fetchAllSales())
}, [dispatch])

const invoiceList = ()=>{

  return ( 
  <>
  <div className="flex">
    filters
  </div>
  <Table
    limit="10"
    headData={invoiceTableHead}
    renderHead={(item, index) => renderHead(item, index)}
    bodyData={sales}
    renderBody={(item, index) => renderBody(item, index)}
  />
  </>)
}


  return (
    <div> 
   <div className="row">
    {/* <div onClick={()=>setShowInvoiceList((state)=>!state)} className="col-3">
          <StatusCard
          
            icon={"bx bx-user"}
            count={sales.length}
            title={"Total Invoice"}
          ></StatusCard>
        </div> */}
    
    </div>
        <div className="row">
          {
            !showInvoiceList ? (<div className="col-12">
            <CreateInvoice/>
        </div>):
        (
          <div className="col-12">
          {
            invoiceList()
          }
        </div>
        )
          }
            
           
        </div>
    </div>
  )
}

export default Invoice